import React from 'react';
import BottomTabBar from './BottomTabBar';

const DashboardLayout = ({ children }) => {
  return (
    <div
      className="bg-background-light dark:bg-background-dark font-display text-slate-900 dark:text-white"
      style={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        // Reserve space for the fixed bottom tab bar (88px)
        paddingBottom: 88,
        boxSizing: 'border-box',
      }}
    >
      <main
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {children}
      </main>

      <BottomTabBar />
    </div>
  );
};

export default DashboardLayout;
